import classNames from 'clsx';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateGoogleAuthSdkStatus } from '../../../actions/auth';
import { oAuthSdkStates } from '../../../constants/auth/oauth';
import {
  OAUTH_GAPI_SIGNIN_ERROR,
  OAUTH_GAPI_SIGNUP_ERROR,
} from '../../../constants/localizations/auth';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import LoadingButton from '../../shared/button/LoadingButton';
import Text from '../../Text';
import css from './oauth-button.module.scss';
import { useGoogleSignIn } from './useGoogleSignIn';

// exported for testing
export const GoogleButton = ({
  googleAuthSdkStatus,
  actionHandler,
  partnerParams,
  source,
  isSignIn,
  isPartner,
  onClick,
  actions,
}) => {
  const { getLocalizedText, locale } = useContext(LocationAndLocalizationContext);
  const isErrorStatus = googleAuthSdkStatus === oAuthSdkStates.error;
  const isLoadingStatus = googleAuthSdkStatus === oAuthSdkStates.loading;

  const handleClick = () => {
    onClick?.();
  };

  const errorText = isSignIn
    ? getLocalizedText(OAUTH_GAPI_SIGNIN_ERROR)
    : getLocalizedText(OAUTH_GAPI_SIGNUP_ERROR);

  const buttonRef = useGoogleSignIn({
    actionHandler,
    source,
    partnerParams,
    actions,
    isErrorStatus,
    locale,
    buttonOptions: { shape: isPartner ? 'default' : 'pill', click_listener: handleClick },
  });

  return (
    <>
      <div
        className={classNames(css.googleButtonContainer, {
          [css.isPartnerFlow]: isPartner,
        })}
        data-testid="googleSignInOauthButton"
      >
        {isLoadingStatus ? (
          <LoadingButton
            className={classNames(css.googleButton, {
              [css.isPartnerFlow]: isPartner,
            })}
          />
        ) : (
          <div ref={buttonRef} />
        )}
      </div>
      {isErrorStatus && <Text name={errorText} className={css.errorText} />}
    </>
  );
};

GoogleButton.propTypes = {
  actionHandler: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  googleAuthSdkStatus: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  partnerParams: PropTypes.object,
  isPartner: PropTypes.bool,
  source: PropTypes.string,
};

export const mapStateToProps = (state) => ({
  googleAuthSdkStatus: get(state, 'auth.googleAuthSdkStatus'),
});

export const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ updateGoogleAuthSdkStatus }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GoogleButton);
